
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 16l1.149-4.265a7.875 7.875 0 01-.83-5.46A7.895 7.895 0 013.283 1.61a7.943 7.943 0 0110.36.668 7.879 7.879 0 01.805 10.316 7.927 7.927 0 01-4.643 3.013 7.949 7.949 0 01-5.489-.755L0 16zm4.523-2.745l.267.157a6.423 6.423 0 007.757-.94 6.365 6.365 0 001.071-7.715 6.398 6.398 0 00-3.091-2.725 6.425 6.425 0 00-4.118-.28 6.406 6.406 0 00-3.434 2.282 6.37 6.37 0 00-1.324 3.897 6.295 6.295 0 00.936 3.308l.168.275-.643 2.38 2.411-.64z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.055 8.768a1.42 1.42 0 00-1.18-.26c-.306.123-.505.59-.703.823a.3.3 0 01-.377.082 5.304 5.304 0 01-2.67-2.22.305.305 0 01.042-.43c.22-.212.383-.475.472-.764.02-.32-.056-.637-.217-.916a2.14 2.14 0 00-.684-1.002.97.97 0 00-1.015.15 2.028 2.028 0 00-.548.722 1.97 1.97 0 00-.174.88c.001.17.023.34.066.504.11.396.278.774.5 1.122.16.267.335.525.524.774a7.955 7.955 0 002.27 2.041c.444.27.919.49 1.415.655a3.218 3.218 0 001.647.252c.32-.047.623-.17.883-.358.26-.187.469-.434.608-.718a.89.89 0 00.07-.55c-.085-.38-.608-.604-.93-.787z","fill":"#fff"}})])
          )
        }
      }
    